import * as React from 'react'
import { ReactElement } from 'react'
import EnumPicker, { EnumPickerLabel, EnumPickerProps } from './EnumPicker'
import { InvoiceStatus } from '../../config/finance/invoiceConfig'

export type InvoiceStatusPickerProps = Partial<EnumPickerProps<InvoiceStatus>> &
    Required<Pick<EnumPickerProps<InvoiceStatus>, 'selectedOptions' | 'onOptionsSelect'>>

// The order matters for dropdowns.
export const InvoiceStatusLabels: Map<InvoiceStatus, EnumPickerLabel> = new Map<InvoiceStatus, EnumPickerLabel>([
    [InvoiceStatus.New, { name: 'invoice.status.new', disabled: false }],
    [InvoiceStatus.Draft, { name: 'invoice.status.draft', disabled: false }],
    [InvoiceStatus.Final, { name: 'invoice.status.final', disabled: false }],
    [InvoiceStatus.Done, { name: 'invoice.status.done', disabled: false }],
    [InvoiceStatus.Settled, { name: 'invoice.status.settled', disabled: false }],
    [InvoiceStatus.Credited, { name: 'invoice.status.credited', disabled: false }],
    [InvoiceStatus.SettledDone, { name: 'invoice.status.settleddone', disabled: false }],
    [InvoiceStatus.CreditedDone, { name: 'invoice.status.crediteddone', disabled: false }],
])

export default function InvoiceStatusPicker(props: InvoiceStatusPickerProps): ReactElement {
    return (
        <EnumPicker<InvoiceStatus>
            options={[...InvoiceStatusLabels.keys()]}
            labels={InvoiceStatusLabels}
            placeholderKey={'invoice.status.placeholder'}
            {...props}
        />
    )
}
